import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasPrivilege } from "../Common/UIComponents";

const PrivateRoute = ({ children, privilege }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (privilege) {
    const privList = Array.isArray(privilege) ? privilege : [privilege];
    const allowed = privList.some((p) => hasPrivilege(p));
    if (!allowed) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default PrivateRoute;
